import { createSlice } from "@reduxjs/toolkit";

export interface OneFilterState {
  school: any;
  grade: any;
  currentPage: any,
}

const initialState: OneFilterState = {
  school: "",
  grade: "",
  currentPage: 1,
};

const oneFilterSlice = createSlice({
  name: "oneFilters",
  initialState,
  reducers: {
    addOneFilter: (state, action) => {
      return (state = action.payload);
    },
  },
});

export const { addOneFilter } = oneFilterSlice.actions;

export const selectOneFilters = (state: { oneFilters: OneFilterState }) => state.oneFilters;

export default oneFilterSlice.reducer;
